"use client";

import { useRouter } from "next/navigation";
import { Button, Typography } from "@shared/ui.primitives";
import { container } from "./index.css";

export const PreviewAlert = () => {
  const router = useRouter();

  return (
    <div className={container}>
      <Typography color="primary-dark" variant="body-md">
        Preview mode is ON!
      </Typography>
      <Button
        onClick={() =>
          // eslint-disable-next-line no-restricted-syntax
          router.push(
            `/api/exit-preview?redirectTo=${encodeURIComponent(window.location.pathname)}`
          )
        }
        text="Exit Preview"
      ></Button>
    </div>
  );
};
